import { ColumnDef, CellContext } from '@tanstack/react-table';
import { FileText } from 'lucide-react';

import { name } from '@/react/docker/containers/ListView/ContainersDatatable/columns/name';
import { state } from '@/react/docker/containers/ListView/ContainersDatatable/columns/state';
import { created } from '@/react/docker/containers/ListView/ContainersDatatable/columns/created';
import { ip } from '@/react/docker/containers/ListView/ContainersDatatable/columns/ip';
import { host } from '@/react/docker/containers/ListView/ContainersDatatable/columns/host';
import { ports } from '@/react/docker/containers/ListView/ContainersDatatable/columns/ports';
import { ContainerListViewModel } from '@/react/docker/containers/types';
import { trimSHA } from '@/docker/filters/utils';
import { Authorized } from '@/react/hooks/useUser';
import { Authorizations } from '@/react/portainer/rbac/authorizations';

import { Link } from '@@/Link';
import { Icon } from '@@/Icon';

const image: ColumnDef<ContainerListViewModel> = {
  header: 'Image',
  accessorFn: (row) => trimSHA(row.Image),
  id: 'image',
  enableHiding: true,
};

const quickActions: ColumnDef<ContainerListViewModel> = {
  header: 'Quick Actions',
  id: 'actions',
  cell: QuickActionsCell,
};

function QuickActionsCell({
  row: { original: container },
}: CellContext<ContainerListViewModel, unknown>) {
  return (
    <div className="inline-flex space-x-1">
      <Authorized
        authorizations={[
          Authorizations.Docker.Container.Logs,
          Authorizations.Docker.Task.Logs,
        ]}
      >
        <Link
          to="edge.browse.containers.container.logs"
          params={{ containerId: container.Id }}
          title="Logs"
          data-cy={`container-logs-${container.Id}`}
        >
          <Icon icon={FileText} className="space-right" />
        </Link>
      </Authorized>
    </div>
  );
}

export const columns = [
  name,
  state,
  quickActions,
  image,
  created,
  ip,
  host,
  ports,
];
